/**
 * @fileoverview Fetch a list of available License Packs for the current business.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import Uri from 'goog:goog.Uri';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {mockRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/mockrequest';
import {GetLicensePacksRequest} from '/src/com/yext/listingslaunchstorm/js/enterprise/selectfeatures/data/getlicensepacksrequest';
import {GetLicensePacksResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/selectfeatures/data/getlicensepacksresponse';
import * as mocks from '/src/com/yext/listingslaunchstorm/js/enterprise/selectfeatures/mocks/licensepackoption';

/**
 * @param {number} savedFilterId
 * @param {AbortSignal} abortSignal
 * @return {Promise<GetLicensePacksResponse>}
 */
export function getLicensePacks(savedFilterId, abortSignal) {
  const request = new GetLicensePacksRequest({savedFilterId});
  const route = new Uri(Routes.getLicensePacks());
  return doRequest('GET_LICENSE_PACKS', abortSignal, route, 'POST', request.toJSON())
    .then(json => {
      return GetLicensePacksResponse.fromJSON(json);
    });
}

export const getLicensePacksMocks = {
  success: abortSignal => mockRequest(abortSignal, resolve =>
    resolve(new GetLicensePacksResponse({
      options: [
        mocks.LICENSE_PACK_OPTION_MOCK_1,
        mocks.LICENSE_PACK_OPTION_MOCK_2,
      ],
    }))),
  failure: abortSignal => mockRequest(abortSignal, (_resolve, reject) =>
    reject(false),
  ),
};
